module.exports = __webpack_public_path__ + "img/main-screen-left.a5288e04.svg";